import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Landing from "./components/Landing";
import AuthorPage from "./components/AuthorPage";
import FeatureList from "./components/FeatureList";
import Footer from "./components/Footer";
import Editorial from "./components/Editorial";
import ScrollToTop from "./components/ScrollToTop";

import "../css/main.scss";
import chevron from "../assets/images/chevron.png";
import data from "../data/copy.json";

window.onload = () => {
  const mountNode = document.getElementById("app");
  const root = createRoot(mountNode);
  root.render(<App />);
};

const App = () => (
  <BrowserRouter basename={process.env.NODE_ENV === "development" ? "/" : "/queer-in-color-2022"}>
    <ScrollToTop>
      <Routes>
        {data.authors.map((d) =>
          <Route path={`/${d.slug}`} key={d.slug} element={
            <div id="author-wrapper">
              <AuthorPage data={d} />
              <div className="hr-wrap">
                <hr />
              </div>
              <Footer details={data.footer} />
            </div>
          } />
        )}
        <Route path="/" element={
          <main>
            <section id="background" />
            <section id="foreground">
              <article>
                <header>
                  <h1>Queer in Color</h1>
                  <section id="chevron-wrapper">
                    <a href="#home"><img src={chevron} alt="Scroll Down" className="chevron" /></a>
                  </section>
                </header>
                <Landing details={data.landing} />
                <FeatureList list={data.authors} />
                <Footer details={data.footer} />
              </article>
            </section>
          </main>
        } />
        <Route path="/editorial" element={
          <main style={{ scrollSnapType: "unset" }}>
            <section id="background" />
            <section id="foreground">
              <article id="editorial-article">
                <div id="buffer-small" />
                <Editorial details={data.editorial} />
                <div className="hr-edit">
                  <hr />
                </div>
                <Footer details={data.footer} />
              </article>
            </section>
          </main>
        } />
      </Routes>
    </ScrollToTop>
  </BrowserRouter >

);

export default App;
